import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Kontaktirajte Nas
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Spremni smo da odgovorimo na sva vaša pitanja i pomognemo vam da pronađete savršena segmentna vrata
            </p>
          </div>
        </div>
      </section>

      {/* Working Hours & CTA */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Working Hours */}
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-12 text-white">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-8">Radno Vreme</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center pb-4 border-b border-slate-700">
                  <span className="text-lg text-gray-300">Ponedeljak - Petak</span>
                  <span className="text-xl font-semibold">08:00 - 18:00</span>
                </div>
                <div className="flex justify-between items-center pb-4 border-b border-slate-700">
                  <span className="text-lg text-gray-300">Subota</span>
                  <span className="text-xl font-semibold">09:00 - 15:00</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-lg text-gray-300">Nedelja</span>
                  <span className="text-xl font-semibold text-red-400">Zatvoreno</span>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="space-y-8">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Spremni za Besplatnu Procenu?
                </h3>
                <p className="text-xl text-gray-600 leading-relaxed mb-8">
                  Kontaktirajte nas danas i dobijte besplatnu procenu za vaša nova segmentna vrata.
                  Naš tim stručnjaka je spreman da vam pomogne.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Pozovite Nas</h4>
                    <a
                      href="tel:+381600706072"
                      className="text-xl font-bold text-red-600 hover:text-red-700 transition-colors"
                    >
                      +381 60 0706 072
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Pošaljite Email</h4>
                    <a
                      href="mailto:stefan@segmentna-vrata.rs"
                      className="text-xl font-bold text-red-600 hover:text-red-700 transition-colors break-all"
                    >
                      stefan@segmentna-vrata.rs
                    </a>
                  </div>
                </div>

                <Button
                  variant="primary"
                  icon="ri-phone-line"
                  href="tel:+381600706072"
                  className="w-full"
                >
                  Besplatna Procena
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;